import { Component, OnInit } from '@angular/core';
import { Gallery, GalleryItem, ImageItem, ThumbnailsPosition, ImageSize } from '@ngx-gallery/core';
import { kesariAnimations } from '../animation';
import { ShareService } from '../service/share.service';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-new-artical-section',
  templateUrl: './new-artical-section.component.html',
  styleUrls: ['./new-artical-section.component.scss'],
  animations: kesariAnimations,
})
export class NewArticalSectionComponent implements OnInit {
  articleItem: any
  currentIndex: any = -1;
  showFlag: any = false;
  // items: GalleryItem[];
  metaData = {
    isProduct: false,
    page: "MICE-ARTICLE"
  }
  constructor(private miceService: ShareService, private meta: Meta, private title: Title) { }

  ngOnInit(): void {
    this.getArticles()
    // this.items = data.map(item =>
    //   new ImageItem({ src: item.srcUrl, thumb: item.previewUrl })
    // );

    //  // Load items into the lightbox
    //  this.basicLightboxExample();

    //  // Load item into different lightbox instance
    //  // With custom gallery config
    //  this.withCustomGalleryConfig();
  }
  getArticles() {

    this.miceService.getArticles().subscribe((param) => {
     // console.log(param)
      this.articleItem = param.data
    })
    this.miceService.getMetaData(this.metaData).subscribe((data) => {
      // console.log(data)
      if (data.length != 0) {
        this.meta.updateTag({ property: 'og:title', content: data[0].meta_title });
        this.meta.updateTag({ name: 'keywords', content: data[0].meta_keyword });
        this.meta.updateTag({ name: 'description', content: data[0].meta_description });
        this.title.setTitle(data[0].meta_title);
        // console.log(data[0].meta_description)
      }

    })
    this.miceService.setCanonicalURL();
  }
  showLightbox(index) {    
    this.currentIndex = index;
    this.showFlag = true;
  }

  closeEventHandler() {
    this.showFlag = false;
    this.currentIndex = -1;
  }
  //  basicLightboxExample() {
  //    this.gallery.ref().load(this.items);
  //  }

  /**
  * Use custom gallery config with the lightbox
  */
  // withCustomGalleryConfig() {

  //   // 2. Get a lightbox gallery ref
  //   const lightboxGalleryRef = this.gallery.ref('anotherLightbox');

  //   // (Optional) Set custom gallery config to this lightbox
  //   lightboxGalleryRef.setConfig({
  //     imageSize: ImageSize.Cover,
  //     thumbPosition: ThumbnailsPosition.Top
  //   });

  //   // 3. Load the items into the lightbox
  //   lightboxGalleryRef.load(this.items);
  // }

}

// const data = [
//   {
//     srcUrl: '../../assets/img/new-artical/DNA-October-12.jpg',
//     previewUrl: '../../assets/img/new-artical/DNA-October-12.jpg'
//   },
//   {
//     srcUrl: '../../assets/img/new-artical/MT-March-12.jpg',
//     previewUrl: '../../assets/img/new-artical/MT-March-12.jpg'
//   },
//   {
//     srcUrl: '../../assets/img/new-artical/MIFTA-1.jpg',
//     previewUrl: '../../assets/img/new-artical/MIFTA-1.jpg'
//   },
//   // {
//   //   srcUrl: '../../assets/img/photo-gallery/mifta_photo3.jpg',
//   //   previewUrl: '../../assets/img/photo-gallery/mifta_photo3.jpg'
//   // }
// ];
